require("dotenv").config({ path: `./.env.${process.env.NODE_ENV}` });

const opsgenie = require("opsgenie-sdk");
const opsGenieApiKey = process.env.OPSGENIE_API_KEY;
class OpsGenie {
	constructor() {
		this.opsgenie = opsgenie;

		this.opsgenie.configure({
			api_key: opsGenieApiKey,
		});
	}

	alert(message) {
		if (process.env.NODE_ENV !== "production") return;
		if (!message) return;
		this.opsgenie.alertV2.create(message, function (error, alert) {
			if (error) {
				console.error(error);
			} else {
			}
		});
	}

	createIncident({ message, serviceId }) {
		if (!message || !serviceId) {
			return;
		}

		let create_incident_json = {
			message: "Some Message",
			serviceId: "Server_ID",
		};

		this.opsgenie.incident.create(create_incident_json, function (error, alert) {
			if (error) {
				console.error(error);
			} else {
			}
		});
	}

	pingHeartbeat(identifierName) {
		const identifier = {
			identifier: identifierName, // should be custom to your created incident
		};

		this.opsgenie.heartbeat.ping(identifier, function (error, heartbeat) {
			if (error) {
				console.error(error);
			} else {
			}
		});
	}

	createHeartbeat(opts) {
		var get_heartbeat_identifier = {
			name: opts.name || "HeartbeatName",
			description: opts.description || "Sample heartbeat description",
			intervalUnit: opts.intervalUnit || "minutes",
			interval: opts.interval || 10,
			enabled: opts.enabled || true,
			ownerTeam: {
				name: "IT Ops",
			},
		};

		this.opsgenie.heartbeat.create(get_heartbeat_identifier, function (error, heartbeat) {
			if (error) {
				console.error(error);
			} else {
			}
		});
	}
}

const opsGenie = new OpsGenie();

module.exports = opsGenie;
